import '@/lib/validation/locale';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppProviders } from '@/app/providers/AppProviders';
import { AppRouter } from '@/app/router/AppRouter';
import '@/styles/index.css';

const container = document.getElementById('root');

// Échec explicite plutôt qu'un `!` : si le conteneur manque, le message doit
// pointer vers index.html et non produire une erreur obscure sur `null`.
if (!container) {
  throw new Error('Élément #root introuvable : vérifiez index.html.');
}

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </StrictMode>,
);
